export var DEFAULT_LOCAL_KEY = 'PANDA_LANG';
export var DEFAULT_COOKIE_KEY = 'x-hng';
export var DEFAULT_SEARCH_KEY = 'lang';
export var DEFAULT_LANG = 'zh-CN';
export var PANDA_DEBUG_SEARCH_KEY = 'panda_debug';
export var PANDA_EVENT = {
  /** 语种发生变化 */
  CHANGE_LANG: 'CHANGE_LANG',
  /** cdn实例初始化完毕 */
  I18N_INIT: 'I18N_INIT'
};
export var BROADCAST_CHANNEL_TOPIC = 'Panda_Broadcast_Channel';
export var URL = {
  'pack-daily': 'https://assets-daily.cainiao-inc.com',
  'pack-prod': 'https://cn.alicdn.com'
};
export var PANDA_INSTANCES = '__PANDA_INSTANCES';
export var PANDA_EXUI = '_PANDA_EXUI';
export var PANDA_I18N_INSTANCE = '__$i18n';
export var PANDA_I18N_PACK = '_PANDA_I18N';
export var PANDA_I18N_CACHED = '__I18N_CACHED';
export * from "./lang";
export var VERSION = '0.2.65';